// lib/services/resource/mesh_resource.ts
import {Resource,ResourceLoadContext} from "./resource"
import { ModelData } from "../geometry/modeldata";
import GlbLoader from "./glb_loader";

export default class MeshResource extends Resource<ModelData> {
  async load(ctx: ResourceLoadContext): Promise<ModelData> {
    const response = await ctx.fetchPrivate(this.key);
    if (!response.ok) {
      throw new Error(`Failed to load mesh: ${this.key}`);
    }

    const bytes = await response.arrayBuffer();
    const loader = new GlbLoader();
    const model = await loader.load(bytes);

    this._value = model;
    return model;
  }

  dispose(_ctx: ResourceLoadContext): void {
      this._value = undefined;
   
  }
}